<template>
  <div class="md:mx-4 lg:mx-8 text-dark">
    <div class="text-center ">


        <div class="flex items-center justify-center">
          <img src="@/assets/images/onemonth.png" alt="Image" class="mx-auto w-full lg:w-2/3">

        </div>
        <h3 class="text-2xl font-black text-black mt-2">achievement</h3>

        <h1 class="text-5xl font-black text-black mb-2">month of momentum</h1>

        <div class="my-6">
           Through self-awareness, self-reflection, and intentional action, we can break free from limiting beliefs, destructive habits, and negative patterns of behavior that hold us back from living our best lives.
        </div>

        <div class="flex items-center justify-center mt-4">
            <vs-button icon-pack="feather" icon="icon-arrow-right" @click="save">all right, let's go!</vs-button>
        </div>

        <div class="font-italic font-sm mt-2">
          *Don't forget to share your successes with others
        </div>
    </div>
  </div>

</template>

<script>

export default {
  components: {
  },
  data () {
   return {
    }
  },
  computed: {
  },
  methods: {
    save () {
      this.$emit('hidePopup')
    }
  }
}
</script>
